function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { InvoiceIntegrationStatusEnum, InvoiceIntegrationStatusDTO } from 'anchor-scout-common/types';
import { IntegrationFailureModel } from "./IntegrationFailureModel";
export let InvoiceIntegrationStatus = /*#__PURE__*/function (InvoiceIntegrationStatus) {
  InvoiceIntegrationStatus["PendingSync"] = "pendingSync";
  InvoiceIntegrationStatus["InvoiceSyncFailed"] = "invoiceSyncFailed";
  InvoiceIntegrationStatus["PaymentSyncFailed"] = "paymentSyncFailed";
  InvoiceIntegrationStatus["RefundSyncFailed"] = "refundSyncFailed";
  InvoiceIntegrationStatus["InvoiceRecorded"] = "invoiceRecorded";
  InvoiceIntegrationStatus["VoidedRecorded"] = "voidedRecorded";
  InvoiceIntegrationStatus["RefundRecorded"] = "refundRecorded";
  InvoiceIntegrationStatus["PaymentRecorded"] = "paymentRecorded";
  return InvoiceIntegrationStatus;
}({});
export class InvoiceIntegrationModel {
  static fromDTO(dto, isZeroAmount) {
    switch (dto.status) {
      case InvoiceIntegrationStatusDTO.Synced:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.InvoiceRecorded,
          date: dto.synced.date
        });
      case InvoiceIntegrationStatusDTO.SyncFailed:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.InvoiceSyncFailed,
          failure: new IntegrationFailureModel(dto.syncFailed)
        });
      case InvoiceIntegrationStatusDTO.PaymentFailed:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.PaymentSyncFailed,
          failure: new IntegrationFailureModel(dto.paymentFailed)
        });
      case InvoiceIntegrationStatusDTO.PendingSync:
        {
          const {
            customerLinked,
            itemsLinked
          } = dto.pendingSync;
          return new InvoiceIntegrationModel({
            status: InvoiceIntegrationStatus.PendingSync,
            customerLinked,
            itemsLinked
          });
        }
      case InvoiceIntegrationStatusDTO.Voided:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.VoidedRecorded,
          date: dto.voided.date
        });
      case InvoiceIntegrationStatusDTO.Paid:
        return new InvoiceIntegrationModel({
          status: isZeroAmount ? InvoiceIntegrationStatus.InvoiceRecorded : InvoiceIntegrationStatus.PaymentRecorded,
          date: dto.paid.date
        });
      case InvoiceIntegrationStatusDTO.Refunded:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.RefundRecorded,
          date: dto.refunded.date
        });
      case InvoiceIntegrationStatusDTO.RefundFailed:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.RefundSyncFailed,
          failure: new IntegrationFailureModel(dto.refundFailed)
        });
    }
  }
  static fromAccountingDTO(dto, isZeroAmount) {
    const accountingIntegrations = dto.map(integration => ({
      type: integration.type,
      integration: InvoiceIntegrationModel.fromDTO(integration.value, isZeroAmount)
    }));
    return accountingIntegrations;
  }
  static fromScoutDTO(dto) {
    switch (dto.status) {
      case InvoiceIntegrationStatusEnum.InvoiceRecorded:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.InvoiceRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.InvoiceSyncFailed:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.InvoiceSyncFailed,
          failure: IntegrationFailureModel.fromScoutDTO(dto.date, dto.customFailure)
        });
      case InvoiceIntegrationStatusEnum.PaymentSyncFailed:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.PaymentSyncFailed,
          failure: IntegrationFailureModel.fromScoutDTO(dto.date, dto.customFailure)
        });
      case InvoiceIntegrationStatusEnum.PendingSync:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.PendingSync,
          customerLinked: false,
          itemsLinked: false
        });
      case InvoiceIntegrationStatusEnum.VoidedRecorded:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.VoidedRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.PaymentRecorded:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.PaymentRecorded,
          date: dto.date
        });
      case InvoiceIntegrationStatusEnum.RefundRecorded:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.RefundRecorded,
          date: dto.date,
          numRefunds: dto.numRefunds
        });
      case InvoiceIntegrationStatusEnum.RefundSyncFailed:
        return new InvoiceIntegrationModel({
          status: InvoiceIntegrationStatus.RefundSyncFailed,
          failure: IntegrationFailureModel.fromScoutDTO(dto.date, dto.customFailure)
        });
    }
  }
  constructor(data) {
    this.data = data;
  }
  isSynced() {
    return [InvoiceIntegrationStatus.InvoiceRecorded, InvoiceIntegrationStatus.VoidedRecorded, InvoiceIntegrationStatus.PaymentRecorded, InvoiceIntegrationStatus.RefundRecorded].includes(this.data.status);
  }
  status() {
    return this.data.status;
  }
  isInvoiceRecorded() {
    return this.data.status === InvoiceIntegrationStatus.InvoiceRecorded;
  }
  isInvoiceSyncFailed() {
    return this.data.status === InvoiceIntegrationStatus.InvoiceSyncFailed;
  }
  isSyncFailed() {
    return [InvoiceIntegrationStatus.InvoiceSyncFailed, InvoiceIntegrationStatus.PaymentSyncFailed, InvoiceIntegrationStatus.RefundSyncFailed].includes(this.data.status);
  }
  isPendingSync() {
    return this.data.status === InvoiceIntegrationStatus.PendingSync;
  }
  isPendingCustomerLinked() {
    return this.data.status === InvoiceIntegrationStatus.PendingSync && !this.data.customerLinked;
  }
  isPendingItemsLinked() {
    return this.data.status === InvoiceIntegrationStatus.PendingSync && !this.data.itemsLinked;
  }
  isPaymentSyncFailed() {
    return this.data.status === InvoiceIntegrationStatus.PaymentSyncFailed;
  }
  isRefundSyncFailed() {
    return this.data.status === InvoiceIntegrationStatus.RefundSyncFailed;
  }
  isPaymentRecorded() {
    return this.data.status === InvoiceIntegrationStatus.PaymentRecorded;
  }
  isRefundRecorded() {
    return this.data.status === InvoiceIntegrationStatus.RefundRecorded;
  }
  accept(visitor) {
    switch (this.data.status) {
      case InvoiceIntegrationStatus.InvoiceRecorded:
        return visitor.whenInvoiceRecorded(this.data);
      case InvoiceIntegrationStatus.VoidedRecorded:
        return visitor.whenVoidedRecorded(this.data);
      case InvoiceIntegrationStatus.InvoiceSyncFailed:
        return visitor.whenInvoiceSyncFailed(this.data);
      case InvoiceIntegrationStatus.PaymentSyncFailed:
        return visitor.whenPaymentSyncFailed(this.data);
      case InvoiceIntegrationStatus.PendingSync:
        return visitor.whenPendingSync(this.data);
      case InvoiceIntegrationStatus.PaymentRecorded:
        return visitor.whenPaymentRecorded(this.data);
      case InvoiceIntegrationStatus.RefundRecorded:
        return visitor.whenRefundRecorded(this.data);
      case InvoiceIntegrationStatus.RefundSyncFailed:
        return visitor.whenRefundSyncFailed(this.data);
    }
  }
  setNumRefunds(numRefunds) {
    if (this.data.status === InvoiceIntegrationStatus.RefundRecorded) {
      return new InvoiceIntegrationModel(_objectSpread(_objectSpread({}, this.data), {}, {
        numRefunds
      }));
    }
    return this;
  }
}